export default __webpack_public_path__ + "static/media/AI.d65532ab.png";